import { createServiceFactory } from '@/services/factory'
import { createHttpBusinessPortalService } from './businessPortal.http'
import { createMockBusinessPortalService } from './businessPortal.mock'

export type { BusinessPortalService } from './businessPortal.service'

export const getBusinessPortalService = createServiceFactory(
  'customers',
  createMockBusinessPortalService,
  createHttpBusinessPortalService,
)
